import React, { Component } from 'react'

const STRINGS = {

    rupees_sign:'&#8377;',
   

  }
  
export default STRINGS;